// extracted by mini-css-extract-plugin
export default {"linkStyle":"JavneNabavke_linkStyle__DpsDQ","iframeStyle":"JavneNabavke_iframeStyle__HRWxU"};